var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"van-image",staticStyle:{"width":"100%","height":"100%"}},[_c('div',{attrs:{"id":"demoH5"}})])}]

export { render, staticRenderFns }